module.exports = __webpack_public_path__ + "images/background/image/2-a78a85a29f2760217e2f3c59d550711c.jpg";